import StarsIcon from "@mui/icons-material/Stars";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Typography from "@mui/material/Typography";

import { VehicleSettlementSurveyResponse } from "../../../types/Survey";
import ResponseSnippet from "./ResponseSnippet";

const VehicleSettlementSurveyResponseCarouselCard = ({
  response,
  displayAccount,
  onClick,
}: {
  response: VehicleSettlementSurveyResponse;
  displayAccount?: boolean;
  onClick?: () => void;
}) => {
  const renderStars = (stars: number) => {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {Array.from({ length: stars }).map((_, index) => (
          <StarsIcon
            fontSize="small"
            key={index}
            sx={{ color: "tertiaryGreen.main" }}
          />
        ))}
      </Box>
    );
  };

  return (
    <Card
      sx={{
        display: "flex",
        flex: 1,
        width: "100%",
        border: "none",
        borderRadius: 0,
      }}
      variant="outlined"
    >
      <CardActionArea
        color="primary"
        sx={{
          display: "flex",
          backgroundColor: "surface.main",
        }}
        disableRipple={true}
        onClick={onClick}
      >
        <Box
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            alignItems: "flex-start",
            textAlign: "left",
          }}
        >
          <Typography variant="titleMedium" color="primary">
            {response.crmContactName}
          </Typography>

          {displayAccount && response.crmAccountName && (
            <Typography variant="bodySmall" color="onSurface.main" mt={0.5}>
              {response.crmAccountName}
            </Typography>
          )}

          <Box sx={{ mr: "136px" }}>
            <ResponseSnippet response={response} />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            {renderStars(response.userexperience)}
            <Typography variant="bodySmall" color="onSurface.main">
              Experience
            </Typography>
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default VehicleSettlementSurveyResponseCarouselCard;
